import ZonePointType from "../../../enums/robot/rooms/zone-point-type";
import IdTypePoint from "./id-type-point";
import RoomData, { isRoomMapDataValid } from "./room-data";

interface Point {
  coordinateX: number;
  coordinateY: number;
  coordinateTheta?: number;
}

export default Point;

export const getSvgCoordinatesFromRosPoint = (
  point: IdTypePoint,
  roomData: RoomData | null
): { x: number; y: number } | null => {
  return getSvgCoordinatesFromSimplePoint({ x: point.coordinateX, y: point.coordinateY }, roomData);
};

export const getSvgCoordinatesFromSimplePoint = (
  point: { x: number; y: number },
  roomData: RoomData | null
): { x: number; y: number } | null => {
  if (point.x == null || point.y == null || roomData == null || !isRoomMapDataValid(roomData)) {
    return null;
  }

  return {
    x: (point.x - roomData.mapInformation.xPosition) / roomData.mapInformation.resolution,
    y:
      (point.y / roomData.mapInformation.resolution -
        roomData.mapInformation.height +
        Math.abs(roomData.mapInformation.yPosition / roomData.mapInformation.resolution)) *
      -1,
  };
};

export const getRosPointFromSvgCoordinates = (x: number, y: number, roomData: RoomData | null): Point | null => {
  if (x == null || y == null || roomData == null || !isRoomMapDataValid(roomData)) {
    return null;
  }

  return {
    coordinateX: x * roomData.mapInformation.resolution + roomData.mapInformation.xPosition,
    coordinateY:
      (-1 * y +
        roomData.mapInformation.height -
        Math.abs(roomData.mapInformation.yPosition / roomData.mapInformation.resolution)) *
      roomData.mapInformation.resolution,
  };
};

export const setPointInRoom = (point: Point, roomData: RoomData) => {
  const svgPoint = getSvgCoordinatesFromRosPoint(
    { ...point, id: "", type: ZonePointType.CleaningZoneCorner } as IdTypePoint,
    roomData
  );
  if (svgPoint == null) {
    return point;
  }

  if (svgPoint.x < 5) {
    svgPoint.x = 5;
  } else if (svgPoint.x > roomData.mapInformation.width - 5) {
    svgPoint.x = roomData.mapInformation.width - 5;
  }

  if (svgPoint.y < 5) {
    svgPoint.y = 5;
  } else if (svgPoint.y > roomData.mapInformation.height - 5) {
    svgPoint.y = roomData.mapInformation.height - 5;
  }
  const newPoint = getRosPointFromSvgCoordinates(svgPoint.x, svgPoint.y, roomData);
  return newPoint ? newPoint : point;
};

export const getDistanceBetweenTwoPoints = (pointA: Point, pointB: Point) => {
  return Math.sqrt(
    Math.pow(pointA.coordinateX - pointB.coordinateX, 2) + Math.pow(pointA.coordinateY - pointB.coordinateY, 2)
  );
};
